import React from "react";

import {
  FieldWrapper,
  SelectDropdown,
  SelectProps,
  SelectPlaceholder,
  DefaultSelectValue,
} from "shared/components";
import { InputFieldWrapper } from "../../styles";
import { useSelectLogic } from "../utils";

interface Props extends SelectProps {
  isAsync?: boolean;
  tabIndex?: number;
}

export const SelectComponent: React.FC<Props> = ({
  name,
  label,
  required,
  disabled,
  placeholder,
  style,
  SelectValue = DefaultSelectValue,
  prefixIcon,
  error,
  note,
  validation,
  options = [],
  readOnly,
  isSearchable = false,
  isCreatable = false,
  isMulti = false,
  onChange,
  onDropdownClose,
  tabIndex,
  ...rest
}) => {
  const { isOpen, isFocused, handleOpen, handleClose, toggleOpen, selectedValue, selectFieldLink } =
    useSelectLogic({
      ...rest,
      name,
      disabled,
      onChange,
      options,
    });

  return (
    <FieldWrapper
      name={name}
      label={label}
      required={required}
      fieldLink={selectFieldLink}
      style={style}
      error={error}
      note={note}
    >
      <InputFieldWrapper
        as="button"
        type="button"
        isPadded
        isFocused={isOpen}
        disabled={disabled} // html disabled
        isDisabled={disabled || readOnly} // disabled styles
        error={!!error}
        onClick={toggleOpen}
        onFocus={handleOpen}
        {...(tabIndex && { tabIndex: tabIndex })}
      >
        {selectedValue ? (
          <SelectValue value={selectedValue} isOpen={isOpen} />
        ) : (
          <SelectPlaceholder label={placeholder} isOpen={isOpen} icon={prefixIcon} />
        )}
      </InputFieldWrapper>
      <SelectDropdown
        name={name}
        options={options}
        selectedValue={selectedValue}
        handleClose={() => {
          handleClose();
          onDropdownClose && onDropdownClose();
        }}
        isOpen={isOpen}
        validation={validation}
        disabled={disabled}
        readOnly={readOnly}
        isSearchable={isSearchable}
        isCreatable={isCreatable}
        isMulti={isMulti}
        isFocused={isFocused}
        onChange={onChange}
        {...rest}
      />
    </FieldWrapper>
  );
};
